import gql from 'graphql-tag';

export const albumForMarketingAccountMatches = gql`
  query albumForMarketingAccountMatches($id: RecordID!) {
    album(id: $id) {
      id
      album_folder {
        id
        join_type
        picture_day_enabled
        account {
          id
          logo_image {
            id
            url
          }
        }
      }
    }
  }
`;
